import {tv} from 'tailwind-variants'
import {StarRating} from '../StarRating'
import type {SocialProofContentProps} from './types'

const socialProofStyles = tv({
  slots: {
    headingContainer: 'flex items-center gap-s2',
    logoContainer: 'gap-10px flex items-center',
    ratingNumberText: 'text-text-default arcadia-subheading-5',
    subText: 'text-text-subdued arcadia-heading-12',
    pressAwardsContainer: 'flex-start flex flex-col gap-s1 pb-s2 pr-s2',
    logoContainer2: 'shrink-0 [&>*]:h-[20px] [&>*]:w-[74px]',
  },
  variants: {
    logoSize: {
      small: {
        logoContainer: 'h-[17px] w-[13px]',
      },
      large: {
        logoContainer: 'h-[24px]',
      },
    },
  },
})

export function SocialProofContent(props: SocialProofContentProps) {
  const {
    pressAwardsContainer,
    logoContainer2,
    subText,
    headingContainer,
    logoContainer,
    ratingNumberText,
  } = socialProofStyles({
    logoSize:
      props.type === 'ratings' && props.displayOption === 'stars'
        ? 'small'
        : 'large',
  })

  switch (props.type) {
    case 'ratings': {
      if (props.displayOption === 'stars') {
        return (
          <div>
            <div className={headingContainer()}>
              <div className={logoContainer()}>{props.logo}</div>
              <StarRating rating={Number(props.ratingNumber)} />
            </div>
            <div>
              <span className={subText()}>
                {props.ratingNumber} / {props.ratingOrigin}
              </span>
            </div>
          </div>
        )
      }
      // default to text
      return (
        <div>
          <div className={headingContainer()}>
            <div className={logoContainer()}>{props.logo}</div>
            <span className={ratingNumberText()}>{props.ratingNumber}</span>
          </div>
          <span className={subText()}>{props.ratingOrigin}</span>
        </div>
      )
    }
    case 'press-or-awards':
      return (
        <div className={pressAwardsContainer()}>
          <div className={logoContainer2()} aria-label={props.companyName}>
            {props.logo}
          </div>
          <span className={subText()}>{props.caption}</span>
        </div>
      )
  }
}
